import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { sessionService } from '../../../application/SessionService';

interface UseSessionMagicLinkProps {
  vehicleId: string;
  routeId: string;
}

type UseSessionMagicLinkResponseProps = ServiceResponse<Function, string>;

export const useSessionMagicLink = ({
  vehicleId,
  routeId,
}: UseSessionMagicLinkProps): UseSessionMagicLinkResponseProps => {
  const {
    isInitialLoading: isLoading,
    isRefetching,
    isError,
    isSuccess,
    refetch,
    data,
  } = useQuery(
    [`drivers_session_magic_link`, vehicleId, routeId],
    () => sessionService.createSessionMagicLink({ vehicleId, routeId }),
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading || isRefetching,
    data: data,
    run: refetch,
  };
};
